webpackJsonp([33],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _TemplateLandingPage = __webpack_require__(590);

var _TemplateLandingPage2 = _interopRequireDefault(_TemplateLandingPage);

var _TwoCols = __webpack_require__(596);

var _TwoCols2 = _interopRequireDefault(_TwoCols);

var _WhyUse = __webpack_require__(595);

var _WhyUse2 = _interopRequireDefault(_WhyUse);

var _NewMenu = __webpack_require__(580);

var _NewMenu2 = _interopRequireDefault(_NewMenu);

var _CenteredTitleSection = __webpack_require__(592);

var _CenteredTitleSection2 = _interopRequireDefault(_CenteredTitleSection);

var _Hero = __webpack_require__(593);

var _Hero2 = _interopRequireDefault(_Hero);

var _CardsEstrategias = __webpack_require__(597);

var _CardsEstrategias2 = _interopRequireDefault(_CardsEstrategias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SalesAutomationv2 = function (_Component) {
    _inherits(SalesAutomationv2, _Component);

    function SalesAutomationv2(props) {
        _classCallCheck(this, SalesAutomationv2);

        return _possibleConstructorReturn(this, (SalesAutomationv2.__proto__ || Object.getPrototypeOf(SalesAutomationv2)).call(this, props));
    }

    _createClass(SalesAutomationv2, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(_NewMenu2.default, {
                    pixelsToShowMenuWhite: 50,
                    mutableMenu: true
                }),
                _react2.default.createElement(
                    _TemplateLandingPage2.default,
                    null,
                    _react2.default.createElement(_Hero2.default, { title: _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                'Software de vendas'
                            ),
                            ' da sua representa\xE7\xE3o comercial'
                        ),
                        description: 'Supere metas, organize pedidos, acompanhe seu desempenho e dos seus prepostos, libere tempo para vender mais e conquistar novos clientes.' }),
                    _react2.default.createElement(
                        _WhyUse2.default,
                        { title: 'Por que sua representa\xE7\xE3o comercial precisa de um software de vendas?', image: 'man-taking-notes' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            'Software de vendas \xE9 um sistema que tem recursos para aumentar a produtividade do representante na rua e a organiza\xE7\xE3o das ind\xFAstrias e distribuidoras que recebem essas vendas.'
                        ),
                        _react2.default.createElement(
                            'h3',
                            null,
                            'Com o software de vendas Mercos, sua representa\xE7\xE3o organiza as tabelas de pre\xE7os e de produtos, emite e controla os pedidos de todas as suas representadas de forma padronizada, acompanha as vendas e performance dos seus prepostos, gera relat\xF3rios e controla o estoque dos produtos com poucos cliques. J\xE1 a empresa, recebe os pedidos padronizados e ainda consegue acompanhar as atividades dos seus representantes. E ainda oferece um aplicativo completo, f\xE1cil de usar e que funciona offline para facilitar o dia a dia do vendedor.'
                        )
                    ),
                    _react2.default.createElement(_CenteredTitleSection2.default, { title: 'O software para potencializar e gerenciar vendas da sua representa\xE7\xE3o' }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'representanteOrganizado', title: 'Representa\xE7\xE3o organizada, \xE1gil e que n\xE3o precisa ter retrabalho', reverse: true }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'mobilidade' }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'potencializaRepresentante', reverse: true }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'semErros' }),
                    _react2.default.createElement(_TwoCols2.default, { sectionName: 'vendaOnline', reverse: true }),
                    _react2.default.createElement(_CardsEstrategias2.default, { title: 'Defina estrat\xE9gias comerciais e acompanhe a execu\xE7\xE3o' })
                )
            );
        }
    }]);

    return SalesAutomationv2;
}(_react.Component);

exports.default = SalesAutomationv2;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(554);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Component) {
    _inherits(Link, _Component);

    function Link(props) {
        _classCallCheck(this, Link);

        var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

        _this.state = {
            isActive: false
        };
        return _this;
    }

    _createClass(Link, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                isActive: window.location.href === window.location.pathname + window.location.hash ? 'active' : false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'a',
                { className: (0, _classnames2.default)('link', this.props.arrow && 'arrow', this.props.className, this.props.color, this.props.model, this.props.weight, this.state.isActive),
                    href: !this.state.isActive ? this.props.href : undefined,
                    onClick: this.props.onClick,
                    onMouseOver: this.props.onMouseOver,
                    target: this.props.target,
                    title: this.props.title,
                    rel: this.props.rel ? this.props.rel : this.props.target === '_blank' ? 'noopener noreferrer' : '',
                    ref: this.props.linkRef },
                this.props.children
            );
        }
    }]);

    return Link;
}(_react.Component);

Link.defaultProps = {
    color: 'linkDark',
    model: 'initial-underline',
    weight: 'medium'
};

Link.propTypes = {
    color: _propTypes2.default.oneOf(['linkDark', 'linkLight', 'green', 'white', 'linkBlack']),
    model: _propTypes2.default.oneOf(['initial-underline', 'hover-underline']),
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    weight: _propTypes2.default.oneOf(['thin', 'extra-light', 'light', 'regular', 'medium', 'semi-bold', 'bold', 'extra-bold', 'black'])
};

exports.default = Link;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(38);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RDGateway = function () {
  function RDGateway() {
    _classCallCheck(this, RDGateway);
  }

  _createClass(RDGateway, [{
    key: "sendToRDStation",
    value: function sendToRDStation(data, redirectLink) {
      var _this = this;

      var dataCookies = {
        cf_origem: _jsCookie2.default.get("mutm_source") || "",
        cf_midia: _jsCookie2.default.get("mutm_medium") || "",
        cf_campanha: _jsCookie2.default.get("mutm_campaign") || "",
        cf_utm_term: _jsCookie2.default.get("mutm_term") || "",
        cf_utm_content: _jsCookie2.default.get("mutm_content") || "",
        cf_fbclid: _jsCookie2.default.get("mfbclid") || "",
        cf_glcid: _jsCookie2.default.get("mgclid") || "",
        cf_wbraid: _jsCookie2.default.get("mwbraid") || "",
        cf_gbraid: _jsCookie2.default.get("mgbraid") || "",
        website: "Mercos",
        cf_page_url: window.location.origin + window.location.pathname,
        cf_page_title: document.title,
        cf_ga4_client_id: _jsCookie2.default.get("_ga") || "",
        cf_ga4_muser_id: _jsCookie2.default.get("MUserID") || ""
      };

      this.hashEmail(data.email).then(function (hashedEmail) {
        var enrichedData = _extends({}, dataCookies, data, { cf_email_hash: hashedEmail });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(enrichedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            enrichedData[key] = String(value);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.sendDataLayer(enrichedData);

        Promise.all([_this.sendToRD(enrichedData), _this.sendToHubspot(enrichedData)]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              responseRD = _ref4[0],
              responseHubspot = _ref4[1];

          if (responseRD || responseHubspot) {
            if (redirectLink) {
              window.location = redirectLink;
            }
          } else {
            //alert("Ooops! Tivemos um pequeno problema no recebimento do formulário. Por favor, tente novamente.")
          }
        });
      });
    }
  }, {
    key: "sendDataLayer",
    value: function sendDataLayer(enrichedData) {
      try {
        window.dataLayer = window.dataLayer || [];
        var dataLayerObject = {
          event: "event_track",
          event_category: "form_submit",
          event_action: enrichedData.event_action || "",
          event_label: (enrichedData.event_label || "").replace(/-/g, "_"),
          MUserId: "",
          emailHash: enrichedData.cf_email_hash || "",
          email: enrichedData.email || "",
          codigo_parceiro: enrichedData.cf_codigo_do_parceiro_meus_pedidos || ""
        };

        if (this.getCompanyType(enrichedData)) {
          dataLayerObject.event_companyType = this.getCompanyType(enrichedData);
        }

        dataLayer.push(dataLayerObject);
        return true;
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "gaexpDataSplit",
    value: function gaexpDataSplit(data) {
      try {
        var arr = data.split(".");
        var value = "";
        return value.concat(arr[2], ".", arr[4]);
      } catch (error) {
        return "";
      }
    }
  }, {
    key: "hashEmail",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(email) {
        var encoder, emailBytes, hashBytes, hashArray, hashHex;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                encoder = new TextEncoder();
                emailBytes = encoder.encode(email.toLowerCase());
                _context.next = 5;
                return crypto.subtle.digest("SHA-256", emailBytes);

              case 5:
                hashBytes = _context.sent;
                hashArray = Array.from(new Uint8Array(hashBytes));
                hashHex = hashArray.map(function (bytes) {
                  return bytes.toString(16).padStart(2, "0");
                }).join("");
                return _context.abrupt("return", hashHex.slice(0, 36));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", "");

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function hashEmail(_x) {
        return _ref5.apply(this, arguments);
      }

      return hashEmail;
    }()
  }, {
    key: "getCompanyType",
    value: function getCompanyType(type) {
      if (type && type.cf_atividade_da_empresa) {
        if (type.cf_atividade_da_empresa === "Representante comercial" || type.cf_atividade_da_empresa === "Representação Comercial") {
          return "representacao_comercial";
        } else if (type.cf_atividade_da_empresa === "Distribuição") {
          return "distribuicao";
        } else if (type.cf_atividade_da_empresa === "Indústria") {
          return "industria";
        } else if (type.cf_atividade_da_empresa === "Outra" || type.cf_atividade_da_empresa === "Outro") {
          return "outro";
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "sendToRD",
    value: function sendToRD(enrichedData) {
      var data = JSON.stringify({
        event_type: "CONVERSION",
        event_family: "CDP",
        payload: enrichedData
      });

      return fetch("https://api.rd.services/platform/conversions?api_key=abSCjrNCSWZvTKmxPEuGiTMxdFFtMlJbyBqX", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer"
        },
        body: data
      }).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      }).catch(function (error) {
        console.log(error);
        return false;
      });
    }
  }, {
    key: "sendToHubspot",
    value: function sendToHubspot(enrichedData) {
      var _hsq = window._hsq = window._hsq || [];
      _hsq.push(["identify", {
        conversion_identifier: enrichedData.conversion_identifier || "",
        company: enrichedData.company_name || "",
        nome: enrichedData.name || "",
        email: enrichedData.email || "",
        telefone: enrichedData.personal_phone || "",
        time: enrichedData.cf_time || "",
        atividade_da_empresa: enrichedData["cf_atividade_da_empresa"] || "",
        numero_de_vendedores: enrichedData["cf_numero_de_vendedores"] || ""
      }]);

      var hubspotForm = {
        fields: [{
          objectTypeId: "0-1",
          name: "email",
          value: enrichedData.email || ""
        }, {
          objectTypeId: "0-1",
          name: "firstname",
          value: enrichedData.name || ""
        }, {
          objectTypeId: "0-1",
          name: "identificador",
          value: enrichedData.conversion_identifier || ""
        }, {
          objectTypeId: "0-1",
          name: "company",
          value: enrichedData.company_name || ""
        }, {
          objectTypeId: "0-1",
          name: "phone",
          value: enrichedData.personal_phone || ""
        }, {
          objectTypeId: "0-1",
          name: "time",
          value: enrichedData.cf_time || ""
        }, {
          objectTypeId: "0-1",
          name: "atividade_da_empresa",
          value: enrichedData["cf_atividade_da_empresa"] || ""
        }, {
          objectTypeId: "0-1",
          name: "numero_de_vendedores",
          value: enrichedData["cf_numero_de_vendedores"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_origem",
          value: enrichedData["cf_origem"] || ""
        }, {
          objectTypeId: "0-1",
          name: "midia",
          value: enrichedData["cf_midia"] || ""
        }, {
          objectTypeId: "0-1",
          name: "campanha",
          value: enrichedData["cf_campanha"] || ""
        }, {
          objectTypeId: "0-1",
          name: "termo",
          value: enrichedData["cf_utm_term"] || ""
        }, {
          objectTypeId: "0-1",
          name: "conteudo",
          value: enrichedData["cf_utm_content"] || ""
        }, {
          objectTypeId: "0-1",
          name: "fbclid",
          value: enrichedData["cf_fbclid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "gclid",
          value: enrichedData["cf_glcid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_wbraid",
          value: enrichedData["cf_wbraid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "gbraid",
          value: enrichedData["cf_gbraid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "tipo_de_conversao",
          value: enrichedData["cf_tipo_de_conversao"] || ""
        }, {
          objectTypeId: "0-1",
          name: "codigo_do_parceiro_meus_pedidos",
          value: enrichedData["cf_codigo_do_parceiro_meus_pedidos"] || ""
        }, {
          objectTypeId: "0-1",
          name: "city",
          value: enrichedData["city"] || ""
        }, {
          objectTypeId: "0-1",
          name: "erp_utilizado",
          value: enrichedData["cf_erp_utilizado"] || ""
        }, {
          objectTypeId: "0-1",
          name: "descricao_da_necessidade",
          value: enrichedData["cf_descricao_da_necessidade"] || ""
        }, {
          objectTypeId: "0-1",
          name: "carteira_clientes_canais",
          value: enrichedData["cf_carteira_clientes_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "nome_do_parceiro__canais1_",
          value: enrichedData["cf_nome_do_parceiro_canais1"] || ""
        }, {
          objectTypeId: "0-1",
          name: "clientes_ativos__canais_",
          value: enrichedData["cf_clientes_ativos_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "ramo_de_atuacao__canais_",
          value: enrichedData["cf_ramo_de_atuacao_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "percentual_perfil_ind_dist__canais_",
          value: enrichedData["cf_percentual_perfil_ind_dist_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "observacoes",
          value: enrichedData["cf_observacoes"] || ""
        }, {
          objectTypeId: "0-1",
          name: "unidade_de_negocio_salesforce",
          value: enrichedData["cf_unidade_de_negocio_salesforce"] || ""
        }, {
          objectTypeId: "0-1",
          name: "site",
          value: enrichedData["website"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_isoptimizetest",
          value: enrichedData["cf_isoptimizetest"] || ""
        }, {
          objectTypeId: "0-1",
          name: "empresa",
          value: enrichedData.company_name || ""
        }, {
          objectTypeId: "0-1",
          name: "telefone",
          value: enrichedData.personal_phone || ""
        }, {
          objectTypeId: "0-1",
          name: "email_hash",
          value: enrichedData.cf_email_hash || ""
        }],
        context: {
          pageUri: window.location.origin + window.location.pathname,
          pageName: document.title
        }
      };

      return fetch("https://api.hsforms.com/submissions/v3/integration/submit/21596284/632b7e2d-915b-4384-86eb-678c7bb78e4a", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(hubspotForm)
      }).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      }).catch(function (error) {
        console.log(error);
        return false;
      });
    }
  }]);

  return RDGateway;
}();

exports.default = RDGateway;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(571);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(573);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(554);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(555);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(560);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(566);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(558);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(567);

var _Utm = __webpack_require__(556);

var _ModalTestimonials = __webpack_require__(584);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(569);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoForm = function (_Component) {
    _inherits(DemoForm, _Component);

    function DemoForm(props) {
        _classCallCheck(this, DemoForm);

        var _this = _possibleConstructorReturn(this, (DemoForm.__proto__ || Object.getPrototypeOf(DemoForm)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                typingTimeout: 0,
                partnerId: props.partnerId
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                company = this.state.name + ' - ' + value;
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    'cf_numero_de_vendedores': this.state.users,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/';
                if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this4 = this;

            if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this4.closeDemoModal();
                    }, className: 'site-simple-modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header-logo' },
                    _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    this.getForm()
                ),
                _react2.default.createElement(_ModalTestimonials2.default, null)
            );
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this5 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this5.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this6 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this6.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this6.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this6.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this6.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this6.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this6.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this7 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this7.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                '\xA0'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this7.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this7.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                '\xA0'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this9 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : 'new-button button-secondary btn-modal ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this9.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this10 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt btn-modal ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this10.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: this.props.buttonShadow ? 'btn-green-shadow btn-trial' : 'new-button button-primary btn-trial button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this11 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    this.props.trialButtonOnly ? _react2.default.createElement(
                        'button',
                        {
                            className: 'btn-green-shadow btn-modal',
                            onClick: function onClick(e) {
                                return _this11.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'quero contratar'
                    ) : this.getTrialAndDemo(),
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { div: true, className: 'show-full-form' },
                        this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoForm;
}(_react.Component);

DemoForm.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool,
    trialButtonOnly: _propTypes2.default.bool
};
DemoForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    trialButtonOnly: false
};
exports.default = DemoForm;

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp;

    var extension = src.split('.').pop();
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !noWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !noWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', {
            className: className + ' ' + desktopClass + ' ' + mobileClass,
            src: '' + src,
            alt: '' + alt
        })
    );
};

exports.default = Picture;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(574);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(555);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(560);

var _Modal2 = _interopRequireDefault(_Modal);

var _InputFloatingLabel = __webpack_require__(569);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _RDGateway = __webpack_require__(558);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(567);

var _Utm = __webpack_require__(556);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var DemoFormB2B = function (_Component) {
    _inherits(DemoFormB2B, _Component);

    function DemoFormB2B(props) {
        _classCallCheck(this, DemoFormB2B);

        var _this = _possibleConstructorReturn(this, (DemoFormB2B.__proto__ || Object.getPrototypeOf(DemoFormB2B)).call(this, props));

        _this.handleActivityChange = function (activity) {
            _this.setState({ selectedActivity: activity });
        };

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopupB2B = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoFormB2B, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                partnerId: props.partnerId
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = (0, _masks.telephoneMask)(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                company = this.state.name + ' - ' + value;
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this2.validateEmail(_this2.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'fale-consultor-b2b',
                    'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'ecommerce_b2b'
                };

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/';
                if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                    redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
                } else if (this.props.euCommerce) {
                    redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/';
                } else if (this.props.b2bPromo) {
                    redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b';
                }
                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this3 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this3.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    this.getForm()
                )
            );
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this4 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração',
                        ' ',
                        this.props.euCommerce ? this.props.euCommerce : '',
                        ' ',
                        this.props.b2bPromo ? this.props.b2bPromo : ''
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        _react2.default.createElement(_InputFloatingLabel2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                '\xA0'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement('img', { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-button-form' },
                    this.getModalButton(),
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'integra\xE7\xE3o com mais de 200 ERPs ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'venda 24h por dia, 7 dias por semana ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this5 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: 'new-button  ' + (this.props.trialAndDemo ? 'button-secondary' : 'button-primary'),
                    onClick: function onClick(e) {
                        return _this5.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.modalButtonText || this.props.children || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this6 = this;

            return _react2.default.createElement(
                'a',
                {
                    href: '.',
                    className: 'button-txt ' + (this.props.darkBg ? 'button-txt-white' : ''),
                    onClick: function onClick(e) {
                        return _this6.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.modalButtonText || 'conheça o E-commerce B2B ›'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            return _react2.default.createElement(
                'div',
                { className: 'wrapper-trial-and-demo mobile-only' },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button button-primary ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick() {
                            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                        },
                        href: '#',
                        title: 'Cadastre-se no Mercos!'
                    },
                    this.props.trialAndDemo
                ),
                this.getModalButton()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper new-form-wrapper-b2b' },
                    this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA(),
                    this.props.showForm && _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.getForm()
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoFormB2B;
}(_react.Component);

DemoFormB2B.propTypes = {
    b2b: _propTypes2.default.bool,
    contaAzul: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    radius: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    buttonOnly: _propTypes2.default.bool,
    modalButtonText: _propTypes2.default.string
};
DemoFormB2B.defaultProps = {
    b2b: false,
    contaAzul: false,
    radius: 'half-rounded',
    buttonOnly: false
};
exports.default = DemoFormB2B;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(554);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading4 = function Heading4(_ref) {
    var children = _ref.children,
        center = _ref.center,
        white = _ref.white,
        gray = _ref.gray,
        bottomSpace = _ref.bottomSpace,
        className = _ref.className;
    return _react2.default.createElement(
        'h4',
        { className: (0, _classnames2.default)('heading4', className, center ? 'text-center' : '', white ? 'heading-white' : '', gray ? 'heading-gray' : '', bottomSpace ? 'bottom-space' : '') },
        children
    );
};

exports.default = Heading4;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(572);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonLink = __webpack_require__(565);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _Modal = __webpack_require__(560);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(566);

var _Input2 = _interopRequireDefault(_Input);

var _Heading = __webpack_require__(570);

var _Heading2 = _interopRequireDefault(_Heading);

var _Paragraph = __webpack_require__(561);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _Button = __webpack_require__(555);

var _Button2 = _interopRequireDefault(_Button);

var _RDGateway = __webpack_require__(558);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'company', 'activeClients'];

var ACTIVITY = {
    erpSalesChannel: 'Canal de Vendas de ERP',
    erpManufacturer: 'Fabricante de ERP',
    integrator: 'Integrador'
};

var CLIENTS = {
    zero: '0%',
    upToTwenty: 'Entre 1% e 20%',
    upToFifty: 'Entre 21% e 50%',
    upToEighty: 'Entre 51% e 80%',
    upToHundred: 'Entre 81% e 100%'
};

var PartnerContactModal = function (_Component) {
    _inherits(PartnerContactModal, _Component);

    function PartnerContactModal(props) {
        _classCallCheck(this, PartnerContactModal);

        var _this = _possibleConstructorReturn(this, (PartnerContactModal.__proto__ || Object.getPrototypeOf(PartnerContactModal)).call(this, props));

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState();
        return _this;
    }

    _createClass(PartnerContactModal, [{
        key: 'getInitialState',
        value: function getInitialState() {
            var initialObject = {
                showDemoModal: false,
                showDemoForm: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                activeClients: '',
                clients: ''
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true,
                showDemoForm: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false,
                showDemoForm: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id,
                value = e.target.value;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(type) {
            this.setState({ 'activity': type });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerClients',
        value: function handlerClients(type) {
            this.setState({ 'clients': type });
        }
    }, {
        key: 'getSelectedClients',
        value: function getSelectedClients(selected) {
            return this.state.clients === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var regexName = /^(.|\s)*\S(.|\s)*/;
            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;

            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo][('name', 'email', 'telephone', 'company', 'activeClients')];
                switch (campo) {
                    case 'email':
                        newState[campo + 'Error'] = !regexEmail.test(_this2.state[campo].toLowerCase());
                        break;
                    case 'name':
                        newState[campo + 'Error'] = !regexName.test(_this2.state[campo]);
                        break;
                    case 'telephone':
                        newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                        break;
                    case 'company':
                        newState[campo + 'Error'] = !_this2.state[campo].length > 0;
                        break;
                    case 'activeClients':
                        newState[campo + 'Error'] = !_this2.state[campo].length > 0;
                        break;
                }
            });

            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, "") : '',
                numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            var _this3 = this;

            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicitou-contato-parceiro',
                    'cf_tipo_de_conversao': 'Solicitou Contato Parceiro',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_clientes_ativos_canais': this.state.activeClients,
                    'cf_ramo_de_atuacao_canais': this.state.activity,
                    'cf_percentual_perfil_ind_dist_canais': this.state.clients
                };

                if (this.state.partnerId) {
                    data['conversion_identifier'] = 'canais-lp', data['cf_codigo_do_parceiro_meus_pedidos'] = this.props.partnerId;
                }

                this.rdGateway.sendToRDStation(data);

                this.setState({
                    showDemoForm: false
                });

                setTimeout(function () {
                    _this3.setState({
                        showDemoModal: false,
                        showDemoForm: true
                    });
                }, 3000);
            }
        }
    }, {
        key: 'componentDidMout',
        value: function componentDidMout() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this4 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this4.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-modal', this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(
                        _Heading2.default,
                        null,
                        'Quer ser um Mpartner?'
                    ),
                    _react2.default.createElement(
                        _Paragraph2.default,
                        null,
                        'Deixe seu contato e venha conquistar mercados com a gente.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '/', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'name' },
                            'Nome'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, autoFocus: true }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'email' },
                            'E-mail'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'telephone' },
                            'Telefone'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15' }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'company' },
                            'Empresa'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'company', value: this.state.company, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.companyError }),
                        _react2.default.createElement(
                            'label',
                            { style: {
                                    marginTop: '20px'
                                } },
                            'Qual \xE9 o ramo de atua\xE7\xE3o da sua empresa?'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'group-buttons' },
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.erpSalesChannel), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.erpSalesChannel);
                                    } },
                                'Canal de vendas de ERP'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.erpManufacturer), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.erpManufacturer);
                                    } },
                                'Fabricante - ERP'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.integrator), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.integrator);
                                    } },
                                'Integrador'
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'activeClients' },
                            'Quantos clientes ativos voc\xEA possui?'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'activeClients', value: this.state.activeClients, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.activeClientsError }),
                        _react2.default.createElement(
                            'label',
                            { style: {
                                    marginTop: '20px'
                                } },
                            'Quanto dos seus clientes correspondem a Ind\xFAstria ou Distribui\xE7\xE3o?'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'group-buttons' },
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.zero), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.zero);
                                    } },
                                '0%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToTwenty), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToTwenty);
                                    } },
                                'At\xE9 20%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToFifty), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToFifty);
                                    } },
                                'At\xE9 50%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToEighty), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToEighty);
                                    } },
                                'At\xE9 80%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToHundred), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToHundred);
                                    } },
                                '81% ou mais'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', radius: 'half-rounded' },
                                'Solicitar contato'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-confirm', !this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement('img', { className: 'success-icon', src: '/images/success.png', alt: 'Solicita\xE7\xE3o enviada com sucesso!' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'paragraph' },
                        'Sua solicita\xE7\xE3o foi enviada com sucesso!'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var size = this.props.size,
                model = this.props.model;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    _ButtonLink2.default,
                    {
                        href: '#',
                        className: this.props.className,
                        onClick: function onClick(e) {
                            return _this5.openDemoModal(e);
                        },
                        model: model,
                        size: size,
                        title: 'Pe\xE7a um contato dos nossos especialistas.',
                        radius: 'half-rounded' },
                    'Seja nosso parceiro'
                ),
                this.state.showDemoModal && this.getDemoModal()
            );
        }
    }]);

    return PartnerContactModal;
}(_react.Component);

PartnerContactModal.propTypes = {
    className: _propTypes2.default.string
};

exports.default = PartnerContactModal;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDeviceDetect = __webpack_require__(578);

var _Link = __webpack_require__(557);

var _Link2 = _interopRequireDefault(_Link);

var _ButtonLink = __webpack_require__(565);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_Component) {
    _inherits(MenuItem, _Component);

    function MenuItem(props) {
        _classCallCheck(this, MenuItem);

        var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));

        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.setWrapperRef = _this.setWrapperRef.bind(_this);

        _this.state = {
            isOpen: false
        };
        return _this;
    }

    _createClass(MenuItem, [{
        key: 'setWrapperRef',
        value: function setWrapperRef(node) {
            this.wrapperRef = node;
        }
    }, {
        key: 'handleClickOutside',
        value: function handleClickOutside(event) {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.toggleDropdown();
            }
        }
    }, {
        key: 'toggleDropdown',
        value: function toggleDropdown(e) {
            e && e.preventDefault();

            if (!_reactDeviceDetect.isMobile) {
                if (this.state.isOpen) {
                    document.removeEventListener('mousedown', this.handleClickOutside);
                    document.removeEventListener('mouseover', this.handleClickOutside);
                } else {
                    document.addEventListener('mousedown', this.handleClickOutside);
                    document.addEventListener('mouseover', this.handleClickOutside);
                }
            }

            this.setState({
                isOpen: !this.state.isOpen
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var type = this.props.type;
            return _react2.default.createElement(
                'li',
                { className: (0, _classnames2.default)('nav-item', this.props.className, this.props.subItems && 'show-dropdown', this.props.newSubItems && 'show-dropdown', this.state.isOpen && 'opened'), ref: this.setWrapperRef },
                type === 'button' ? _react2.default.createElement(
                    _ButtonLink2.default,
                    { className: 'menu-cta-button',
                        color: this.props.color,
                        model: this.props.model || 'outline',
                        radius: 'half-rounded',
                        size: 'small',
                        href: this.props.href,
                        target: this.props.target,
                        title: this.props.title,
                        onClick: this.props.onClick,
                        shake: this.props.shake
                    },
                    this.props.children
                ) : _react2.default.createElement(
                    _Link2.default,
                    _extends({ className: 'nav-link' + (type === 'mobile' ? '-mobile' : ''),
                        color: this.props.color,
                        href: this.props.href,
                        title: this.props.title,
                        model: this.props.model || 'hover-underline',
                        target: this.props.target,
                        onClick: this.props.onClick
                    }, this.props.subItems && _extends({ onClick: function onClick(e) {
                            return _this2.toggleDropdown(e);
                        } }, !_reactDeviceDetect.isMobile && { onMouseOver: function onMouseOver(e) {
                            return _this2.toggleDropdown(e);
                        } }), this.props.newSubItems && _extends({ onClick: function onClick(e) {
                            return _this2.toggleDropdown(e);
                        } }, !_reactDeviceDetect.isMobile && { onMouseOver: function onMouseOver(e) {
                            return _this2.toggleDropdown(e);
                        } })),
                    this.props.children
                ),
                this.props.subItems && _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu-mercos' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        this.props.subItems.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: 'menu-subitem-' + index },
                                _react2.default.createElement(
                                    _Link2.default,
                                    { model: 'hover-underline',
                                        href: item.href,
                                        title: item.title,
                                        target: item.target },
                                    item.content
                                )
                            );
                        })
                    )
                ),
                this.props.newSubItems && _react2.default.createElement(
                    'div',
                    { className: 'new-dropdown-menu-mercos' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        this.props.newSubItems.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: 'menu-subitem-' + index },
                                _react2.default.createElement(
                                    _Link2.default,
                                    { model: 'hover-underline',
                                        href: item.href,
                                        title: item.title,
                                        color: 'linkBlack',
                                        target: item.target },
                                    item.url && _react2.default.createElement('img', { alt: item.title, src: item.url }),
                                    item.content
                                )
                            );
                        })
                    )
                ),
                this.props.newSubItemsv2 && _react2.default.createElement(
                    'div',
                    { className: 'new-dropdown-menu-mercos' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        this.props.newSubItemsv2.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: 'menu-subitem-' + index },
                                _react2.default.createElement(
                                    _Link2.default,
                                    { model: 'hover-underline',
                                        href: item.href,
                                        title: item.title,
                                        color: 'linkBlack',
                                        target: item.target },
                                    item.url && _react2.default.createElement('img', { alt: item.title, src: item.url }),
                                    item.content
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return MenuItem;
}(_react.Component);

MenuItem.defaultProps = {
    color: 'linkLight',
    href: '.'
};
exports.default = MenuItem;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(2);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(579);

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: 'IE',
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DeviceTypes.Mobile;
};

var isTabletType = function isTabletType() {
  return device.type === DeviceTypes.Tablet;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DeviceTypes.SmartTv;
};

var isBrowserType = function isBrowserType() {
  return device.type === DeviceTypes.Browser;
};

var isWearableType = function isWearableType() {
  return device.type === DeviceTypes.Wearable;
};

var isConsoleType = function isConsoleType() {
  return device.type === DeviceTypes.Console;
};

var isAndroidType = function isAndroidType() {
  return os.name === OsTypes.Android;
};

var isWindowsType = function isWindowsType() {
  return os.name === OsTypes.Windows;
};

var isMacOsType = function isMacOsType() {
  return os.name === OsTypes.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OsTypes.WindowsPhone;
};

var isIOSType = function isIOSType() {
  return os.name === OsTypes.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BrowserTypes.Chrome;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BrowserTypes.Firefox;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BrowserTypes.Chromium;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BrowserTypes.Edge;
};

var isYandexType = function isYandexType() {
  return browser.name === BrowserTypes.Yandex;
};

var isSafariType = function isSafariType() {
  return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BrowserTypes.MobileSafari;
};

var isOperaType = function isOperaType() {
  return browser.name === BrowserTypes.Opera;
};

var isIEType = function isIEType() {
  return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BrowserTypes.MIUI;
};

var isSamsungBrowserType = function isSamsungBrowserType() {
  return browser.name === BrowserTypes.SamsungBrowser;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.28",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=255;var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){return typeof str1===STR_TYPE?str2.toLowerCase().indexOf(str1.toLowerCase())!==-1:false},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str,len){str=str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"");return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldSafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}},oldEdge:{version:{.1:"12.",21:"13.",31:"14.",39:"15.",41:"16.",42:"17.",44:"18."}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/(?:edge|edgios|edga|edg)\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i,/(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/\s]+([\w\.]+)/i],[VERSION,[NAME,"Opera Mini"]],[/\sopr\/([\w\.]+)/i],[VERSION,[NAME,"Opera"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(ba?idubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i,/(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[VERSION,[NAME,"UCBrowser"]],[/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure Browser"],VERSION],[/focus\/([\w\.]+)/i],[VERSION,[NAME,"Firefox Focus"]],[/opt\/([\w\.]+)/i],[VERSION,[NAME,"Opera Touch"]],[/coc_coc_browser\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,"Opera Coast"]],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Browser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/\s(electron)\/([\w\.]+)\ssafari/i,/(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i,/(LBBROWSER)/i],[NAME],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/FBAN\/FBIOS|FB_IAB\/FB4A/i],[[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/\s]([\w\.-]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+)\s.*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,"Chrome WebView"],VERSION],[/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldSafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/ile\svr;\srv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,"Firefox Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,/(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|armv?8e?l?)\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i],[MODEL,[VENDOR,"Samsung"],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i,/\ssamsung[\s-]([\w-]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,"Samsung"],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\s\w]*);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/\((ipad);[\w\s\),;-]+apple/i,/applecoremedia\/[\w\.]+\s\((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i,/\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/\b(poco[\s\w]+)(?:\sbuild|\))/i,/\b;\s(\w+)\sbuild\/hm\1/i,/\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,/\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i,/\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/;\s(\w+)\sbuild.+\soppo/i,/\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/\svivo\s(\w+)(?:\sbuild|\))/i,/\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\s(rmx[12]\d{3})(?:\sbuild|;)/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i,/\smot(?:orola)?[\s-](\w*)/i,/((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/(lm-?f100[nv]?|nexus\s[45])/i,/lg[e;\s\/-]+((?!browser|netcast)\w+)/i,/\blg(\-?[\d\w]+)\sbuild/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(ideatab[\w\-\s]+)/i,/lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia\s\d+)/i,/nokia[\s_-]?([\w\.-]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/droid.+;\s(pixel\sc)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/sony\stablet\s[ps]\sbuild\//i,/(?:sony)?sgp\w+(?:\sbuild\/|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,"Sony"],[TYPE,TABLET]],[/\s(kb2005|in20[12]5|be20[12][59])\b/i,/\ba000(1)\sbuild/i,/\boneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)(\sbuild\/|\))/i,/(kf[a-z]+)(\sbuild\/|\)).+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i],[[MODEL,"Fire Phone"],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((playbook);[\w\s\),;-]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i],[MODEL,[VENDOR,"ASUS"],[TYPE,TABLET]],[/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i],[MODEL,[VENDOR,"ASUS"],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+;\s(m[1-5]\snote)\sbuild/i,/\bmz-([\w-]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i,/(microsoft);\s(lumia[\s\w]+)/i,/(lenovo)[_\s-]?([\w-]+)/i,/linux;.+(jolla);/i,/droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i,/[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i,/[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i,/\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i,/\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(surface\sduo)\s/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,TABLET]],[/droid\s[\d\.]+;\s(fp\du?)\sbuild/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/\s(u304aa)\sbuild/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/[;\/]\s?(rct\w+)\sbuild/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/[;\/\s](venue[\d\s]{2,7})\sbuild/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/[;\/]\s(tm\d{3}\w+)\sbuild/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/;\s(nx\d{3}j)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/[;\/]\s?(gen\d{3})\sbuild.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/[;\/]\s?(zur\d{3})\sbuild/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/[;\/]\s?((zeki)?tb.*\b)\sbuild/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/[;\/]\s([yr]\d{2})\sbuild/i,/[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/[;\/]\s?(ns-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/;\s(ph-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/[;\/]\s?tu_(1491)\sbuild/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w\s]+)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint)\s(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,"Zebra"],[TYPE,TABLET]],[/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,"Zebra"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[345portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i],[[VENDOR,"LG"],[TYPE,SMARTTV]],[/(apple)\s?tv/i],[VENDOR,[MODEL,"Apple TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/droid.+aft([\w])(\sbuild\/|\))/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i],[[TYPE,SMARTTV]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i],[MODEL,[VENDOR,"Zebra"],[TYPE,WEARABLE]],[/(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]],[/(phone)/i],[[TYPE,MOBILE]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,"BlackBerry"]],[/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,"Chromecast"]],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation)\s([wids345portablevuch]+)/i,/(xbox);\s+xbox\s([^\);]+)/i,/(mint)[\/\s\(\)]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i,/\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku)\s(\w+)/i],[NAME,VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua==="object"){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!=="undefined"&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={name:undefined,version:undefined};mapper.rgx.call(_browser,_ua,_rgxmap.browser);_browser.major=util.major(_browser.version);return _browser};this.getCPU=function(){var _cpu={architecture:undefined};mapper.rgx.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={name:undefined,version:undefined};mapper.rgx.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={name:undefined,version:undefined};mapper.rgx.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?util.trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!=="undefined"){window.UAParser=UAParser}}var $=typeof window!=="undefined"&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(557);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(555);

var _Button2 = _interopRequireDefault(_Button);

var _MenuItem = __webpack_require__(577);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _PartnerContactModal = __webpack_require__(576);

var _PartnerContactModal2 = _interopRequireDefault(_PartnerContactModal);

var _Utm = __webpack_require__(556);

__webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import PromotionalModal from '../../components/site/PromotionalModal/PromotionalModal'

//import TopBar from './TopBar'

var softwareSubItems = [{
    href: '/industrias',
    title: 'Veja como o Mercos pode potencializar sua Indústria.',
    content: 'Indústrias',
    url: '/images/icon-industrias.svg'
}, {
    href: '/distribuidoras',
    title: 'Veja como o Mercos pode potencializar sua Distribuidora.',
    content: 'Distribuidoras',
    url: '/images/icon-distribuidoras.svg'
}, {
    href: '/representantes-comerciais',
    title: 'Veja como o Mercos pode potencializar o Representante Comercial.',
    content: 'Representantes',
    url: '/images/icon-representates.svg'
}],
    partnersSubItems = [{
    href: '/integracao-erp',
    title: 'Encontre o ERP ideal com integração ao Mercos.',
    content: 'ERPs integrados'
}, {
    href: '/parceiros',
    title: 'Conheça nosso programa de Parceiros.',
    content: 'Seja parceiro'
}],
    conteudoSubItems = [{
    href: 'https://blog.mercos.com/',
    title: 'Novidades no blog',
    content: 'Blog',
    target: '_blank'
}, {
    href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI',
    title: 'Mercoscast',
    content: 'Mercoscast',
    target: '_blank'
}],
    participantsSubItems = [{
    href: '/experience/ingressos',
    title: 'Comprar agora meu ingresso.',
    content: 'Ingressos'
}, {
    href: '/experience/onde-ficar',
    title: 'Saiba onde ficar hospedado e quais as atividades da região.',
    content: 'Onde ficar'
}, {
    href: '/experience/duvidas',
    title: 'Tire suas dúvidas sobre o Mercos Experience.',
    content: 'Dúvidas'
}],
    videosSubItems = [{
    href: '/mercoscast',
    title: 'Ouça nosso podcast.',
    content: 'Mercoscast'
}, {
    href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hUoq30m-PK8Zx-S-lDYExX-',
    title: 'Veja nosso Mercos Minuto',
    content: 'Mercos Minuto',
    target: '_blank'
}, {
    href: '/blog/lives',
    title: 'Assista nossas lives',
    content: 'Lives'
}];

var NewMenu = function (_Component) {
    _inherits(NewMenu, _Component);

    function NewMenu(props) {
        _classCallCheck(this, NewMenu);

        var _this = _possibleConstructorReturn(this, (NewMenu.__proto__ || Object.getPrototypeOf(NewMenu)).call(this, props));

        _this.handleScroll = function () {
            var pixelsToShowMenuWhite = _this.props.pixelsToShowMenuWhite || 50;
            var scrolledFromTop = window.scrollY;

            if (window.scrollY <= pixelsToShowMenuWhite) {
                _this.setState({
                    whiteBackground: _this.props.whiteBackground || false,
                    showTopBarMargin: false
                });
            } else {
                _this.setState({
                    whiteBackground: true,
                    showTopBarMargin: false
                });
            }

            var isOnTop = scrolledFromTop === 0;
            if (_this.state.isOnTop !== isOnTop) {
                _this.setState({ isOnTop: isOnTop });
            }
        };

        _this.state = {
            openedMenu: false,
            whiteBackground: _this.props.whiteBackground,
            compoundUtmUrl: '',
            showTopBarMargin: false,
            isOnTop: true
        };
        return _this;
    }

    _createClass(NewMenu, [{
        key: 'clickOpenMenu',
        value: function clickOpenMenu() {
            this.setState({ openedMenu: !this.state.openedMenu });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.mutableMenu || this.props.whiteBackground) {
                window.removeEventListener('scroll', this.handleScroll);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.mutableMenu || this.props.whiteBackground) {
                window.addEventListener('scroll', this.handleScroll);
            }
        }
    }, {
        key: 'isTopBarVisible',
        value: function isTopBarVisible() {
            return this.state.showTopBarMargin && !this.props.removeTopBarMargin;
        }
    }, {
        key: 'getSiteMenu',
        value: function getSiteMenu() {
            var _this2 = this;

            var whiteBg = this.state.whiteBackground;
            var loginOnly = this.props.loginOnly;

            return _react2.default.createElement(
                'nav',
                {
                    className: (0, _classnames2.default)('new-navmenu navbar navbar-expand-lg navbar-transition menu-lateral effect-1', whiteBg ? 'new-navmenu-white' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin', this.state.openedMenu && 'opened', { 'fixed-top': this.props.fixed }, { 'menu-on-top': this.state.isOnTop })
                },
                '   ',
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container menu-nav-container new-home-container') },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal.' },
                        _react2.default.createElement('img', {
                            className: this.state.openedMenu ? 'new-menu-logo-mercos opened' : 'new-menu-logo-mercos',
                            alt: 'Logomarca Mercos',
                            src: this.state.openedMenu ? "/images/site/logo-minimal.svg" : whiteBg ? "/images/site/logo-mercos-colored.svg" : "/images/logo_mercos_footer.svg"
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'nav-close-wrapper', onClick: function onClick() {
                                return _this2.clickOpenMenu();
                            } },
                        this.state.openedMenu ? 'FECHAR' : 'MENU'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this2.clickOpenMenu();
                            } },
                        _react2.default.createElement('img', { src: this.state.openedMenu ? '/images/icon-close.svg' : '/images/icon-hamburger-' + (whiteBg ? 'black' : 'white') + '.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            !loginOnly && _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', className: 'highlight', href: '/', title: 'P\xE1gina inicial da Mercos.' },
                                    'Home'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Conhe\xE7a o Mercos.', newSubItems: softwareSubItems },
                                    'Software'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', className: 'highlight', href: '/planos-e-precos', title: 'Conhe\xE7a nossos Planos e Pre\xE7os.' },
                                    'Planos e Pre\xE7os'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Saiba mais sobre nossos parceiros.', newSubItems: partnersSubItems },
                                    'Integra\xE7\xF5es'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Conhe\xE7a nosso conte\xFAdo.', newSubItems: conteudoSubItems },
                                    'Conte\xFAdo'
                                )
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { type: 'button', className: 'button-menu-mobile', model: 'success', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }, href: '#', title: 'Cadastre-se no Mercos.' },
                                'comece gr\xE1tis'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkBlack', model: 'outline', className: (0, _classnames2.default)('highlight', 'link-menu'), onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
                                    }, href: '#', title: 'Acesse o Mercos!' },
                                'Ja possui conta? acesse aqui'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav new-home-navbar' },
                            !loginOnly && _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkLight', href: '.', title: 'Conhe\xE7a o Mercos.', newSubItems: softwareSubItems },
                                    'Software'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkLight', className: 'highlight', href: '/planos-e-precos', title: 'Conhe\xE7a nossos Planos e Pre\xE7os.' },
                                    'Planos e Pre\xE7os'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkLight', href: '.', title: 'Saiba mais sobre nossos parceiros.', newSubItems: partnersSubItems },
                                    'Integra\xE7\xF5es'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkLight', href: '.', title: 'Conhe\xE7a nosso conte\xFAdo.', newSubItems: conteudoSubItems },
                                    'Conte\xFAdo'
                                )
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { className: 'button-menu-home', shake: true, type: 'button', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }, href: '#', title: 'Cadastre-se no Mercos!' },
                                'comece gr\xE1tis'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkLight' }, {
                                    className: (0, _classnames2.default)('menu-item-enter', !whiteBg && 'menu-item-enter-white'),
                                    shake: true,
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
                                    },
                                    href: '#',
                                    title: 'Acesse o Mercos!'
                                }),
                                'Entrar'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.getSiteMenu()
            );
        }
    }]);

    return NewMenu;
}(_react.Component);

NewMenu.propTypes = {
    bigPadding: _propTypes2.default.bool,
    whiteBackground: _propTypes2.default.bool,
    logoOnly: _propTypes2.default.bool,
    mutableMenu: _propTypes2.default.bool,
    pixelsToShowMenuWhite: _propTypes2.default.number,
    isNewHome: _propTypes2.default.bool,
    fixed: _propTypes2.default.bool, // Added prop type for fixed
    topBarType: _propTypes2.default.string,
    removeTopBarMargin: _propTypes2.default.bool
};

NewMenu.defaultProps = {
    bigPadding: false,
    whiteBackground: false,
    logoOnly: false,
    mutableMenu: false,
    pixelsToShowMenuWhite: 100,
    fixed: true, // Default value for fixed
    topBarType: '',
    removeTopBarMargin: false
};

exports.default = NewMenu;

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(557);

var _Link2 = _interopRequireDefault(_Link);

var _Utm = __webpack_require__(556);

__webpack_require__(583);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var footerItems = [{
        title: 'Mercos', subItems: [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }, { name: 'Integrações', url: 'https://mercos.com/integracao-erp/', redirect: false }, { name: 'Trabalhe Conosco', url: 'https://mercos.gupy.io/', redirect: false, target: '_blank' }, { name: 'Sobre nós', url: 'https://mercos.com/sobre/', redirect: false }, { name: 'Aviso de Privacidade', url: 'https://mercos.com/aviso-de-privacidade/', redirect: false, target: '_blank' }, { name: 'Portal de Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', redirect: false, target: '_blank' }, { name: 'Relatório de Igualdade Salarial', url: '/documentos/relatorio-igualdade-salarial-mercos.pdf', redirect: false, target: '_blank' }]
    }, {
        title: 'Software', subItems: [{ name: 'Indústrias', url: 'https://mercos.com/industrias/', redirect: false }, { name: 'Distribuidoras', url: 'https://mercos.com/distribuidoras/', redirect: false }, { name: 'Representantes', url: 'https://mercos.com/representantes-comerciais/', redirect: false }, { name: 'E-commerce B2B', url: 'https://mercos.com/e-commerce-b2b/', redirect: false }, { name: 'Mercos Pay', url: 'https://mercos.com/mercos-pay', redirect: false, target: '_blank' }, {
            name: 'Força de vendas',
            url: 'https://mercos.com/forca-vendas/',
            redirect: false,
            h4: true,
            target: '_self'
        }]
    }, {
        title: 'Conteúdo', subItems: [{ name: 'Nosso Blog', url: 'https://blog.mercos.com/', redirect: false }, {
            name: 'Mercoscast',
            url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI',
            redirect: false
        }, {
            name: _react2.default.createElement(
                _react.Fragment,
                null,
                'E-commerce B2B:',
                _react2.default.createElement('br', null),
                ' O que \xE9?'
            ),
            url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e',
            redirect: false,
            h4: true,
            target: '_blank'
        }]
    }, {
        title: 'Ajuda', subItems: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', redirect: false }]
    }];

    var footerSection = function footerSection(item) {
        return _react2.default.createElement(
            'div',
            { className: 'footer-menu-item' },
            _react2.default.createElement(
                'h4',
                { white: true, className: 'footer-title' },
                item.title
            ),
            _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                item.subItems.map(function (subitem) {
                    return _react2.default.createElement(
                        'li',
                        null,
                        subitem.h4 ? _react2.default.createElement(
                            'h4',
                            null,
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    className: 'footer-link-item ',
                                    href: subitem.redirect ? null : subitem.url,
                                    onClick: subitem.redirect ? function () {
                                        return (0, _Utm.redirectWithCookies)(subitem.url);
                                    } : null,
                                    title: 'Veja como o Mercos pode potencializar sua Ind\xFAstria.',
                                    target: subitem.target
                                },
                                subitem.name
                            )
                        ) : _react2.default.createElement(
                            _Link2.default,
                            {
                                className: "footer-link-item  " + (subitem.greenClass ? subitem.greenClass : null),
                                href: subitem.redirect ? null : subitem.url,
                                onClick: subitem.redirect ? function () {
                                    return (0, _Utm.redirectWithCookies)(subitem.url);
                                } : null,
                                title: 'Veja como o Mercos pode potencializar sua Ind\xFAstria.',
                                target: subitem.target
                            },
                            subitem.name
                        )
                    );
                })
            )
        );
    };

    var getContactInfo = function getContactInfo() {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'h5',
                { className: 'footer-title text-align-center' },
                '(47) 3481-8050'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'text-item-block footer-atendimento' },
                'Segunda a Quinta das 9h \xE0s 17h',
                _react2.default.createElement('br', null),
                'Sexta das 9h30 \xE0s 17h'
            ),
            _react2.default.createElement(
                'div',
                { className: 'footer-apps' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank' },
                    _react2.default.createElement('img', { srcSet: '/images/site/btn-android.png', alt: 'Aplicativo Mercos para Android' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/meus-pedidos/id485511628', target: '_blank' },
                    _react2.default.createElement('img', { srcSet: '/images/site/btn-ios.png', alt: 'Aplicativo Mercos para iOS' })
                )
            )
        );
    };

    return _react2.default.createElement(
        'div',
        { className: 'container-new-footer-v2' },
        _react2.default.createElement(
            'div',
            { className: 'new-footer-bg' },
            _react2.default.createElement(
                'div',
                { className: 'new-container new-footer' },
                _react2.default.createElement(
                    'div',
                    { className: 'footer-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'footer-details' },
                        _react2.default.createElement(
                            'div',
                            { className: 'footer-menu-item phone-mobile' },
                            getContactInfo()
                        ),
                        footerItems.map(function (item) {
                            return footerSection(item);
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'footer-menu-item phone-web' },
                            getContactInfo()
                        )
                    ),
                    _react2.default.createElement('div', { className: 'footer-divider-gradient' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'footer-about-mercos' },
                        _react2.default.createElement(
                            'div',
                            { className: 'logo-mercos' },
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    href: '/',
                                    className: 'social-media-icon'
                                },
                                _react2.default.createElement('img', { src: '/images/site/new-home/logo-mercos-nuvini.svg', alt: 'Logomarca da Mercos' })
                            )
                        ),
                        _react2.default.createElement(
                            'h6',
                            { className: 'cnpj-text' },
                            'Simplest Software Ltda CNPJ: 12.496.510/0001-80 Insc. Estadual: ISENTO ',
                            _react2.default.createElement('br', null),
                            ' Av. Rolf Wiest, 277 (4\xBA andar) Bom Retiro - Joinville/SC | CEP: 89223-005'
                        ),
                        _react2.default.createElement(
                            'h6',
                            { className: 'terms' },
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    href: '/termos-e-condicoes/',
                                    target: '_blank'
                                },
                                'Termos e Condi\xE7\xF5es'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'social-container' },
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    target: '_blank',
                                    href: 'https://www.facebook.com/mercosoficial',
                                    className: 'social-media-icon expand-icon'
                                },
                                _react2.default.createElement('img', {
                                    src: '/images/site/new-home/mercos-no-facebook.svg',
                                    alt: 'P\xE1gina oficial da Mercos no Facebook'
                                })
                            ),
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    target: '_blank',
                                    href: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw',
                                    className: 'social-media-icon expand-icon'
                                },
                                _react2.default.createElement('img', {
                                    src: '/images/site/new-home/mercos-no-youtube.svg',
                                    alt: 'Canal oficial da Mercos no Youtube'
                                })
                            ),
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    target: '_blank',
                                    href: 'https://www.instagram.com/mercosoficial/',
                                    className: 'social-media-icon expand-icon'
                                },
                                _react2.default.createElement('img', {
                                    target: '_blank',
                                    src: '/images/site/new-home/mercos-no-instagram.svg',
                                    alt: 'Perfil oficial da Mercos no Instagram'
                                })
                            ),
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    target: '_blank',
                                    href: 'https://www.linkedin.com/company/mercos/mycompany/',
                                    className: 'social-media-icon expand-icon'
                                },
                                _react2.default.createElement('img', {
                                    src: '/images/site/new-home/mercos-no-linkedin.svg',
                                    alt: 'P\xE1gina oficial da Mercos no Linkedin'
                                })
                            ),
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    target: '_blank',
                                    href: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1',
                                    className: 'social-media-icon expand-icon'
                                },
                                _react2.default.createElement('img', {
                                    src: '/images/site/new-home/mercos-no-spotify.svg',
                                    alt: 'Perfil oficial da Mercos no Spotify'
                                })
                            )
                        )
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(585);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches"
}, {
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia"
}, {
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação"
}, {
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações"
}];
var TESTIMONIALS2 = [{
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos"
}, {
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati"
}, {
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman"
}];

var ModalTestimonials = function (_Component) {
    _inherits(ModalTestimonials, _Component);

    function ModalTestimonials() {
        _classCallCheck(this, ModalTestimonials);

        return _possibleConstructorReturn(this, (ModalTestimonials.__proto__ || Object.getPrototypeOf(ModalTestimonials)).apply(this, arguments));
    }

    _createClass(ModalTestimonials, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col' },
                    TESTIMONIALS.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col testimonials-col2' },
                    TESTIMONIALS2.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ModalTestimonials;
}(_react.Component);

exports.default = ModalTestimonials;

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _DemoFormB2B = __webpack_require__(568);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

var _DemoForm = __webpack_require__(562);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

__webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardTrialNew = function CardTrialNew(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        contaAzul = _ref.contaAzul,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? '' : _ref$page,
        text = _ref.text,
        children = _ref.children,
        _ref$isEcommerce = _ref.isEcommerce,
        isEcommerce = _ref$isEcommerce === undefined ? false : _ref$isEcommerce,
        isReps = _ref.isReps,
        partnerId = _ref.partnerId,
        radius = _ref.radius,
        ctaText = _ref.ctaText,
        horizontalCard = _ref.horizontalCard,
        trialText = _ref.trialText,
        modalLink = _ref.modalLink,
        inlineBtns = _ref.inlineBtns,
        modalSmall = _ref.modalSmall,
        ctaBtn = _ref.ctaBtn;
    return _react2.default.createElement(
        'section',
        { className: 'trial-background new-box-trial-wrapper ' + (horizontalCard ? 'new-trial-horizontal' : '') + ' ' + (className ? className : '') },
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('box-trial', page) },
            _react2.default.createElement(
                'div',
                { className: 'container text-center' },
                isEcommerce ? _react2.default.createElement(
                    'h5',
                    { className: 'card-trial-title' },
                    text
                ) : _react2.default.createElement(
                    'h2',
                    { className: 'card-trial-title' },
                    text
                ),
                isEcommerce ? _react2.default.createElement(
                    _DemoFormB2B2.default,
                    null,
                    ctaText
                ) : ctaBtn ? ctaBtn : isReps ? _react2.default.createElement(_DemoForm2.default, { darkBg: true }) : _react2.default.createElement(_DemoForm2.default, { trialAndDemo: trialText ? trialText : 'teste grátis', darkBg: true, ctaText: true, modalLink: modalLink ? true : false, showOr: horizontalCard ? true : false, inlineBtns: inlineBtns ? true : false, modalSmall: modalSmall ? true : false })
            )
        )
    );
};

CardTrialNew.propTypes = {
    children: _propTypes2.default.node,
    contaAzul: _propTypes2.default.bool,
    page: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    radius: _propTypes2.default.string
};

CardTrialNew.defaultProps = {
    contaAzul: false,
    partnerId: '',
    text: _react2.default.createElement(
        _react.Fragment,
        null,
        'Junte-se a mais de 8 mil clientes',
        _react2.default.createElement('br', null),
        ' que est\xE3o potencializando vendas'
    )
};

exports.default = CardTrialNew;

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paragraph = __webpack_require__(561);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckList = function CheckList(_ref) {
    var className = _ref.className,
        title = _ref.title,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('check-list-container', className) },
        title && _react2.default.createElement(
            _Paragraph2.default,
            { className: 'check-list-title' },
            title
        ),
        _react2.default.createElement(
            'ul',
            { className: 'check-list' },
            children
        )
    );
};

CheckList.propTypes = {};

exports.default = CheckList;

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paragraph = __webpack_require__(561);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckListItem = function CheckListItem(_ref) {
    var className = _ref.className,
        children = _ref.children;
    return _react2.default.createElement(
        'li',
        { className: (0, _classnames2.default)('check-list-item', className) },
        children
    );
};

CheckListItem.propTypes = {};

exports.default = CheckListItem;

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _CardTrialv = __webpack_require__(586);

var _CardTrialv2 = _interopRequireDefault(_CardTrialv);

var _Footer = __webpack_require__(581);

var _Footer2 = _interopRequireDefault(_Footer);

__webpack_require__(591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var b2b = _ref.b2b,
        card = _ref.card,
        children = _ref.children,
        hero = _ref.hero,
        headData = _ref.headData,
        distribuidor = _ref.distribuidor,
        footerCTAText = _ref.footerCTAText,
        representative = _ref.representative,
        marketplace = _ref.marketplace;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        headData && _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
                'title',
                null,
                headData.pageTitle
            ),
            _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { property: 'og:url', content: headData.ogUrl }),
            _react2.default.createElement('link', { rel: 'canonical', href: headData.ogUrl }),
            headData.noFollow && _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'new-layout new-landing-page ' + (b2b ? 'new-landing-page-b2b' : '') + ' ' + (marketplace ? 'marketplace-partner' : '') },
            children
        ),
        representative ? '' : _react2.default.createElement(_CardTrialv2.default, { className: 'card-trial-landing-pages', trialText: 'comece gr\xE1tis', isEcommerce: true,
            text: b2b ? 'Todos os dias milhares de varejistas já compram online por catálogo B2B. Não fique para trás.' : distribuidor ? 'Comece a usar o app de vendas para o distribuidor que já potencializou o processo comercial de mais de 8 mil empresas' : footerCTAText ? footerCTAText : 'Junte-se a mais de 35 mil diretores comerciais, gerentes e representantes que est\xE3o potencializando e gerenciando suas vendas'
        }),
        _react2.default.createElement(_Footer2.default, null)
    );
});

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CenteredTitleSection;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CenteredTitleSection(props) {
  return _react2.default.createElement(
    'section',
    { className: 'section-centered-title container' },
    _react2.default.createElement(
      'h2',
      { className: 'title' },
      props.title
    )
  );
}

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Hero;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(564);

var _Picture2 = _interopRequireDefault(_Picture);

var _DemoForm = __webpack_require__(562);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _DemoFormB2B = __webpack_require__(568);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Hero(props) {
    var demoForm = props.b2b ? _react2.default.createElement(_DemoFormB2B2.default, { buttonOnly: true }) : props.stackedButtons ? _react2.default.createElement(_DemoForm2.default, { darkBg: true }) : _react2.default.createElement(_DemoForm2.default, { darkBg: true, showOr: true, modalLink: true });

    var heroImg = void 0;
    switch (true) {
        case props.app:
            heroImg = _react2.default.createElement(_Picture2.default, {
                className: 'hero-img-full-right hero-image-app',
                src: '/images/site/landing-pages/hero-app.png',
                alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B',
                mobileSrc: '/images/site/landing-pages/hero-app-mobile.png'
            });
            break;
        case props.platform:
            heroImg = _react2.default.createElement(_Picture2.default, {
                className: 'hero-img-full-right',
                src: '/images/site/landing-pages/hero-plataform.png',
                alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B',
                mobileSrc: '/images/site/landing-pages/hero-plataform-mobile.png'
            });
            break;
        case props.b2b:
            heroImg = _react2.default.createElement(_Picture2.default, {
                noWebp: true,
                className: 'hero-img-full-right',
                src: '/images/site/landing-pages/hero-b2b.png',
                alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B',
                mobileSrc: '/images/site/landing-pages/hero-b2b-mobile.png'
            });
            break;
        case props.parceiros:
            heroImg = _react2.default.createElement(_Picture2.default, {
                noWebp: true,
                className: 'hero-img-full-right',
                src: '/images/site/landing-pages/hero-b2b.png',
                alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B',
                mobileSrc: '/images/site/landing-pages/hero-b2b-mobile.png'
            });
            break;
        default:
            heroImg = _react2.default.createElement(_Picture2.default, {
                className: 'hero-img-full-right',
                src: '/images/site/landing-pages/hero-sistemas.png',
                alt: 'Mercos, sistema de vendas, emiss\xE3o de pedidos e e-commerce B2B',
                mobileSrc: '/images/site/landing-pages/hero-sistemas-mobile.png'
            });
            break;
    }

    return _react2.default.createElement(
        'div',
        { className: 'new-main-banner-v2 new-hero ' + (props.whiteBg ? 'new-hero-white-bg' : 'new-hero-purple-bg') + ' hero-v2' + (props.stackedButtons ? ' stacked-buttons' : '') },
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'column' },
                _react2.default.createElement(
                    'div',
                    { className: 'title-wrapper' },
                    props.overtitle ? _react2.default.createElement(
                        'div',
                        { className: 'label-small' },
                        props.overtitle
                    ) : "",
                    _react2.default.createElement(
                        'h1',
                        { className: 'title' },
                        props.title
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'main-subheading-container' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'description' },
                        props.description
                    )
                ),
                demoForm
            ),
            _react2.default.createElement('div', { className: 'column desktop-only' })
        ),
        heroImg,
        _react2.default.createElement('div', { className: 'full-width-white-fill' })
    );
}

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(564);

var _Picture2 = _interopRequireDefault(_Picture);

var _DemoForm = __webpack_require__(562);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _DemoFormB2B = __webpack_require__(568);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IMAGES = {
    'man-taking-notes': {
        url: '/images/site/landing-pages/order-system.png',
        alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        mobile: '/images/site/landing-pages/order-system-mobile.png'
    },
    'distribuidoras': {
        url: '/images/site/landing-pages/distribuidoras.png',
        alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        mobile: '/images/site/landing-pages/distribuidoras-mobile.png'
    },
    'man-looking-ipad': {
        url: '/images/site/landing-pages/sales-platform.png',
        alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        mobile: '/images/site/landing-pages/sales-platform-mobile.png'
    }
};

var QUOTES = {
    V1: {
        card1: "Vendas em catálogos virtuais para o mercado B2B devem alcançar mais de 6 trilhões de dólares em 2020",
        card2: "As vendas por catálogo B2B nos EUA crescem 7,7% ao ano e devem chegar a US$ 1.13 trilhões em 2020",
        card3: {
            quote1: "das compras são feitas fora do horário comercial",
            quote2: "das compras são feitas no final de semana",
            quote3: "dos acessos são feitos via celular"
        },
        card4: "20% dos clientes Mercos já faturam mais de 20% pelo catálogo B2B"
    },
    V2: {
        card1: "Pedidos online para o mercado B2B devem alcançar mais de 6 trilhões de dólares em 2020",
        card2: "Pedidos online B2B nos EUA crescem 7,7% ao ano e devem chegar a US$ 1.13 trilhões em 2020",
        card3: {
            quote1: "dos pedidos feitos no horário comercial",
            quote2: "das pedidos feitos no final de semana",
            quote3: "dos acessos são feitos via celular"
        },
        card4: "20% dos clientes Mercos já faturam mais de 20% emitindo pedidos online pelo e-commerce B2B"
    },
    V3: {
        card1: "Vendas por catálogo online para o mercado B2B devem alcançar mais de 6 trilhões de dólares em 2020",
        card2: "As vendas por catálogo online B2B nos EUA crescem 7,7% ao ano e devem chegar a US$ 1.13 trilhões em 2020",
        card3: {
            quote1: "das compras são feitas fora do horário comercial",
            quote2: "das compras são feitas no final de semana",
            quote3: "dos acessos são feitos via celular"
        },
        card4: _react2.default.createElement(
            _react.Fragment,
            null,
            '20% dos clientes Mercos ',
            _react2.default.createElement(
                'strong',
                null,
                'j\xE1 faturam mais de 20%'
            ),
            ' pelo cat\xE1logo online'
        )
    }
};

var WhyUse = function (_Component) {
    _inherits(WhyUse, _Component);

    function WhyUse(props) {
        _classCallCheck(this, WhyUse);

        var _this = _possibleConstructorReturn(this, (WhyUse.__proto__ || Object.getPrototypeOf(WhyUse)).call(this, props));

        _this.reverse = _this.props.reverse;
        _this.sectionData = IMAGES[_this.props.image] || {};
        return _this;
    }

    _createClass(WhyUse, [{
        key: 'render',
        value: function render() {
            var _props$variation = this.props.variation,
                variation = _props$variation === undefined ? 'V1' : _props$variation;

            var selectedQuotes = QUOTES[variation] || QUOTES['V1'];

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'section',
                    { className: 'why-use' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container two-col  ' + (this.reverse ? 'reverse' : '') },
                        _react2.default.createElement(
                            'div',
                            { className: 'column' },
                            _react2.default.createElement(
                                'h2',
                                { className: '' + (this.props.b2b ? 'title-light' : 'title') },
                                this.props.title
                            ),
                            this.props.b2b ? '' : _react2.default.createElement(_Picture2.default, {
                                className: 'mobile-only',
                                src: this.sectionData.mobile,
                                alt: this.sectionData.alt,
                                mobileSrc: this.sectionData.mobile ? this.sectionData.mobile : null
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'description' },
                                this.props.children
                            ),
                            this.props.b2b ? _react2.default.createElement(
                                _DemoFormB2B2.default,
                                { buttonOnly: true },
                                'saiba mais'
                            ) : _react2.default.createElement(_DemoForm2.default, { inlineBtns: true, trialAndDemo: 'teste gr\xE1tis', modalLink: true })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'column' },
                            this.props.b2b ? _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'b2b-four-cards' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'quote' },
                                            '\u201C',
                                            selectedQuotes.card1,
                                            '\u201D'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'company-logo' },
                                            _react2.default.createElement('img', { src: '/images/site/landing-pages/b2b/frost-sullivan.png', alt: 'Frost Sullivan' })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'quote' },
                                            '\u201C',
                                            selectedQuotes.card2,
                                            '\u201D'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'company-logo' },
                                            _react2.default.createElement('img', { src: '/images/site/landing-pages/b2b/forrester.png', alt: 'Forrester' })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'v-quote' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'percent' },
                                                '20%'
                                            ),
                                            ' ',
                                            selectedQuotes.card3.quote1
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'v-quote' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'percent' },
                                                '10%'
                                            ),
                                            ' ',
                                            selectedQuotes.card3.quote2
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'v-quote' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'percent' },
                                                '40%'
                                            ),
                                            ' ',
                                            selectedQuotes.card3.quote3
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'quote' },
                                            '\u201C',
                                            selectedQuotes.card4,
                                            '\u201D'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'company-logo' },
                                            _react2.default.createElement('img', { src: '/images/site/logo-mercos-colored.svg', alt: 'Mercos', width: '110' })
                                        )
                                    )
                                )
                            ) : _react2.default.createElement(_Picture2.default, {
                                className: 'desktop-only',
                                src: this.sectionData.url,
                                alt: this.sectionData.alt
                            }),
                            this.props.b2b ? _react2.default.createElement(
                                _DemoFormB2B2.default,
                                { buttonOnly: true },
                                'saiba mais'
                            ) : ''
                        )
                    )
                )
            );
        }
    }]);

    return WhyUse;
}(_react.Component);

exports.default = WhyUse;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(564);

var _Picture2 = _interopRequireDefault(_Picture);

var _CheckList = __webpack_require__(588);

var _CheckList2 = _interopRequireDefault(_CheckList);

var _CheckListItem = __webpack_require__(589);

var _CheckListItem2 = _interopRequireDefault(_CheckListItem);

var _DemoForm = __webpack_require__(562);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SECTIONS = {
    vendasOrganizadas: {
        title: 'Vendas organizadas, ágeis e sem retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Todas as vendas num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Mais tempo para o seu time'
            ),
            ': chega de ficar digitando pedidos no fim do dia'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    gestaoPedidos: {
        title: 'Gestão de pedidos organizada, ágil e sem retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Todas as vendas num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    representanteOrganizado: {
        title: 'Representante organizado, ágil e que não precisa ter retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Todas as vendas num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Mais tempo'
            ),
            ': sem necessidade de um profissional exclusivo para digita\xE7\xE3o de pedidos ou fazer o representante digitar pedidos no fim do dia'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    mobilidade: {
        title: 'Mobilidade para os representantes',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Funciona offline'
            ),
            ' e fecha vendas mesmo sem internet.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Funciona no tablet, celular e no notebook.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'O Aplicativo para representantes mais f\xE1cil de usar do mercado.'
        )],
        img: {
            url: '/images/site/landing-pages/mobilidade-representantes.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/mobilidade-representantes-mobile.png'
        }
    },
    entradaPedidos: {
        title: 'Entrada de pedidos organizada, ágil e sem retrabalho',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Pedidos num s\xF3 lugar'
            ),
            ': pare de receber pedidos por whatsapp, e-mail ou anota\xE7\xF5es no bloco e na planilha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economia de 8 horas por semana'
            ),
            ': chega de redigitar pedidos no fim do dia.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Padronize o visual de todos os pedidos'
            ),
            ', configurando de acordo com a sua necessidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie o pedido em PDF'
            ),
            ' por e-mail com apenas 1 clique'
        )],
        img: {
            url: '/images/site/landing-pages/entrada-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png'
        }
    },
    semErrosParceiros: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Sem erros,',
            _react2.default.createElement('br', null),
            'mais resultados'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'Integrado ao seu ERP o pedido \xE9 enviado direto ao faturamento'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Garanta que os representantes apliquem descontos e pol\xEDticas comerciais corretamente'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure m\xFAltiplas tabelas de pre\xE7o por vendedor, cliente ou outro crit\xE9rio a sua escolha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Controle o estoque e mostre para os representantes a quantidade de itens dispon\xEDvel'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Calcule automaticamente vendas com impostos como ICMS, ST e IPI'
        )],
        img: {
            url: '/images/site/landing-pages/sem-erros.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/sem-erros-mobile.png'
        }
    },
    semErros: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Sem erros,',
            _react2.default.createElement('br', null),
            'mais resultados'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Integrado ao seu ERP'
            ),
            ': al\xE9m de poder integrar com qualquer ERP, o Mercos conta com mais de 200 ERPs parceiros'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Garanta que os representantes apliquem ',
            _react2.default.createElement(
                'b',
                null,
                'descontos e pol\xEDticas comerciais'
            ),
            ' corretamente'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure ',
            _react2.default.createElement(
                'b',
                null,
                'm\xFAltiplas tabelas de pre\xE7o por vendedor'
            ),
            ', cliente ou outro crit\xE9rio a sua escolha'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Controle o estoque'
            ),
            ' e mostre para os representantes a quantidade de itens dispon\xEDvel'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Calcule automaticamente'
            ),
            ' pedidos com impostos como ICMS, ST e IPI'
        )],
        img: {
            url: '/images/site/landing-pages/sem-erros.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/sem-erros-mobile.png'
        }
    },
    imagemProfissional: {
        title: 'Imagem profissional no cliente',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'Apresente um ',
            _react2.default.createElement(
                'b',
                null,
                'cat\xE1logo digital com fotos'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Atenda seus clientes de forma organizada desde a apresenta\xE7\xE3o at\xE9 o fechamento do pedido'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Tenha o ',
            _react2.default.createElement(
                'b',
                null,
                'hist\xF3rico de compra de cada cliente'
            ),
            ' e guie os pr\xF3ximos passos da negocia\xE7\xE3o'
        )],
        img: {
            url: '/images/site/landing-pages/imagem-profissional.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/imagem-profissional-mobile.png'
        }
    },
    potencialize: {
        title: 'Potencialize suas vendas',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'O aplicativo faz ',
            _react2.default.createElement(
                'b',
                null,
                'sugest\xF5es de venda'
            ),
            ' para o representante: produtos para reposi\xE7\xE3o, lan\xE7amentos e promo\xE7\xF5es'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Aumente em at\xE9 11%'
            ),
            ' a rentabilidade dos pedidos emitidos'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure a rentabilidade de cada produto e valorize os pedidos mais rent\xE1veis'
        )],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png'
        }
    },
    aplicativoPotencializa: {
        title: 'Aplicativo que potencializa o representante na hora da venda',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Venda em qualquer lugar mesmo sem internet'
            ),
            ': o sistema funciona offline'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Sugest\xF5es de venda para o representante'
            ),
            ': produtos para reposi\xE7\xE3o, lan\xE7amentos e promo\xE7\xF5es'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Hist\xF3rico completo do cliente'
            ),
            ', para n\xE3o esquecer de nenhuma oportunidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Aumento de 11% na rentabilidade das vendas'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Imagem profissional'
            ),
            ': cat\xE1logo digital com fotos de todos os produtos'
        )],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png'
        }
    },
    potencializaRepresentante: {
        title: 'Potencializa o representante na hora da venda',
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Sugest\xF5es de venda'
            ),
            ': produtos para reposi\xE7\xE3o, lan\xE7amentos e promo\xE7\xF5es'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Hist\xF3rico completo do cliente'
            ),
            ': para n\xE3o esquecer de nenhuma oportunidade'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Aumento de 11% na rentabilidade das vendas'
            )
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Imagem profissional'
            ),
            ': cat\xE1logo digital com fotos de todos os produtos'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Configure a rentabilidade de cada produto e valorize os',
            _react2.default.createElement(
                'b',
                null,
                ' pedidos mais rent\xE1veis'
            )
        )],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png'
        }
    },
    vendaOnline: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Venda online para lojistas de todo o Brasil, 24h por dia'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Loja virtual exclusiva'
            ),
            ' para vender para seus clientes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Conquiste novos mercados'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Esteja ',
            _react2.default.createElement(
                'b',
                null,
                'dispon\xEDvel para vendas a qualquer hora'
            ),
            ', quando o seu cliente quiser comprar'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Aliado do vendedor e do televendas: ofere\xE7a um vendedor online para os seus representantes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economize'
            ),
            ' em deslocamentos, passagens, hospedagens e alimenta\xE7\xE3o'
        )],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png'
        }
    },
    vendaOnlineParceiros: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Venda online para lojistas de todo o Brasil, 24h por dia'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'E-commerce B2B exclusivo para automatizar vendas de reposi\xE7\xE3o para seus clientes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Aliado do representante e do televendas: ofere\xE7a um vendedor online para seu time comercial'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Economize em deslocamentos, passagens, hospedagens e alimenta\xE7\xE3o'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Conquiste novos mercados'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Esteja dispon\xEDvel para vendas a qualquer hora, quando o seu cliente quiser comprar'
        )],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png'
        }
    },
    receba24h: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Receba pedidos online ',
            _react2.default.createElement('br', null),
            '24h por dia'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Loja virtual exclusiva'
            ),
            ' para vender para seus clientes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Conquiste novos mercados'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Esteja ',
            _react2.default.createElement(
                'b',
                null,
                'dispon\xEDvel para vendas a qualquer hora'
            ),
            ', quando o seu cliente quiser comprar'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Aliado do vendedor e do televendas: ofere\xE7a um vendedor online para os seus representantes'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Economize'
            ),
            ' em deslocamentos, passagens, hospedagens e alimenta\xE7\xE3o'
        )],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png'
        }
    },
    gerencieVendedores: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Gerencie seus',
            _react2.default.createElement('br', null),
            ' vendedores'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            'Agenda para controle e organiza\xE7\xE3o de visitas'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Registro de atividades acess\xEDvel para gestor e vendedor'
            ),
            ': saiba exatamente o que aconteceu em cada visita'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            'Garanta que os vendedores apliquem descontos e pol\xEDticas comerciais corretamente'
        )],
        img: {
            url: '/images/site/landing-pages/gerencie-vendedores.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/gerencie-vendedores-mobile.png'
        }
    },
    organizeUmSoLugar: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Organize tudo em um s\xF3 lugar'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine erros'
            ),
            ': emita pedidos de forma pr\xE1tica, respeitando as tabelas de pre\xE7os sem necessidade de redigita\xE7\xE3o.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Exporte pedidos em PDF'
            ),
            ': com apenas um clique envie pedidos por e-mail ou WhatsApp.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine as planilhas'
            ),
            ': organize pedidos, clientes e tabelas de pre\xE7os de todas as suas representadas em um \xFAnico sistema.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/organize.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/organize.png'
        }
    },
    organizeUmSoLugarRep: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Organize tudo em um s\xF3 lugar'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine erros'
            ),
            ': emita pedidos de forma pr\xE1tica, respeitando as tabelas de pre\xE7os sem necessidade de redigita\xE7\xE3o.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Envie pedidos por Whatsapp'
            ),
            ': com apenas um clique exporte pedidos em pdf e envie por e-mail ou whatsapp.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Elimine as planilhas'
            ),
            ': organize pedidos, clientes e tabelas de pre\xE7os de todas as suas representadas em um \xFAnico sistema.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/organize.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/organize.png'
        }
    },
    definaMetas: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Defina metas, acompanhe seu desempenho e suas comiss\xF5es'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Acompanhe a evolu\xE7\xE3o das suas vendas'
            ),
            ': acesse relat\xF3rios em tempo real e controle os recebimentos por representada.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Gerencie sua equipe'
            ),
            ': acompanhe os resultados do seu time e defina estrat\xE9gias com base em dados.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/metas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/metas.png'
        }
    },
    definaMetasRep: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Defina metas, acompanhe seu desempenho e suas comiss\xF5es'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Acompanhe a evolu\xE7\xE3o das suas vendas'
            ),
            ': acesse relat\xF3rios em tempo real e controle os recebimentos por representada.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Gerencie sua equipe'
            ),
            ': acompanhe os resultados do seu time e defina estrat\xE9gias com base em dados.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/metas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/metas.png'
        }
    },
    monitoreClientes: {
        title: _react2.default.createElement(
            _react.Fragment,
            null,
            'Monitore sua carteira de clientes'
        ),
        checklist: [_react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Relat\xF3rios de Curva ABC'
            ),
            ': tenha clareza dos clientes que trazem o maior ou menor retorno e defina estrat\xE9gias personalizadas.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Mapa de carteira por regi\xE3o'
            ),
            ': veja seu desempenho comercial em um mapa por estados e munic\xEDpios.'
        ), _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'b',
                null,
                'Esteja sempre \xE0 frente'
            ),
            ': obtenha insights valiosos sobre produtos e oportunidades de vendas.'
        )],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/monitore.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/monitore.png'
        }
    }
};

var TwoCols = function (_Component) {
    _inherits(TwoCols, _Component);

    function TwoCols(props) {
        _classCallCheck(this, TwoCols);

        var _this = _possibleConstructorReturn(this, (TwoCols.__proto__ || Object.getPrototypeOf(TwoCols)).call(this, props));

        _this.reverse = _this.props.reverse;
        _this.sectionData = SECTIONS[_this.props.sectionName] || {};
        _this.demoCTA = _this.props.demoCTA;
        return _this;
    }

    _createClass(TwoCols, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'section',
                    { className: 'container two-col ' + (this.reverse ? 'reverse' : '') },
                    _react2.default.createElement(
                        'div',
                        { className: 'column' },
                        this.props.imgBeforeTitle && _react2.default.createElement(_Picture2.default, {
                            className: 'mobile-only',
                            src: this.sectionData.img.mobile,
                            alt: this.sectionData.title,
                            mobileSrc: this.sectionData.img.mobile ? this.sectionData.img.mobile.url : ''
                        }),
                        _react2.default.createElement(
                            'h3',
                            { className: 'title' },
                            this.props.title ? this.props.title : this.sectionData.title
                        ),
                        !this.props.imgBeforeTitle && _react2.default.createElement(_Picture2.default, {
                            className: 'mobile-only',
                            src: this.sectionData.img.mobile,
                            alt: this.sectionData.title,
                            mobileSrc: this.sectionData.img.mobile ? this.sectionData.img.mobile.url : ''
                        }),
                        _react2.default.createElement(
                            _CheckList2.default,
                            null,
                            this.sectionData.checklist.map(function (item, index) {
                                return _react2.default.createElement(
                                    _CheckListItem2.default,
                                    { key: index },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        item
                                    )
                                );
                            })
                        ),
                        this.demoCTA ? _react2.default.createElement(_DemoForm2.default, { modalLink: true, inlineBtns: true }) : ''
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'column' },
                        _react2.default.createElement(_Picture2.default, {
                            className: 'desktop-only',
                            src: this.sectionData.img.url,
                            alt: this.sectionData.title,
                            mobileSrc: ''
                        })
                    )
                )
            );
        }
    }]);

    return TwoCols;
}(_react.Component);

exports.default = TwoCols;


TwoCols.propTypes = {
    sectionName: _propTypes2.default.oneOf(Object.keys(SECTIONS)).isRequired
};

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CardsEstrategias;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(564);

var _Picture2 = _interopRequireDefault(_Picture);

var _DemoForm = __webpack_require__(562);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

__webpack_require__(594);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardsEstrategias(props) {
    return _react2.default.createElement(
        _react.Fragment,
        null,
        props.CTA ? _react2.default.createElement(
            'section',
            { className: 'new-sales-cta' },
            _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(_DemoForm2.default, { trialAndDemo: 'teste gr\xE1tis', ctaText: true })
            )
        ) : '',
        _react2.default.createElement(
            'section',
            { className: 'cards-estrategias' },
            _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                    'h2',
                    { className: 'title' },
                    props.title
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'card' },
                    _react2.default.createElement(_Picture2.default, {
                        className: 'new-sales-features-img',
                        src: '/images/site/landing-pages/forca-vendas/evolucao.png',
                        alt: 'Recurso de evolu\xE7\xE3o de vendas do for\xE7a de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                    }),
                    _react2.default.createElement(
                        'h4',
                        { className: 'card-title' },
                        'Evolu\xE7\xE3o de vendas'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'card-description' },
                        'Acompanhe objetivos e a evolu\xE7\xE3o das vendas diariamente'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card' },
                    _react2.default.createElement(_Picture2.default, {
                        className: 'new-sales-features-img',
                        src: '/images/site/landing-pages/forca-vendas/positivacao.png',
                        alt: 'Recurso de positiva\xE7\xE3o de clientes do for\xE7a de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                    }),
                    _react2.default.createElement(
                        'h4',
                        { className: 'card-title' },
                        'Positiva\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'card-description' },
                        'Veja em tempo real quantos clientes compraram de voc\xEA por per\xEDodo'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card' },
                    _react2.default.createElement(_Picture2.default, {
                        className: 'new-sales-features-img',
                        src: '/images/site/landing-pages/forca-vendas/analise.png',
                        alt: 'Recurso de mapa de calor de clientes do for\xE7a de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                    }),
                    _react2.default.createElement(
                        'h4',
                        { className: 'card-title' },
                        'An\xE1lise por regi\xF5es'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'card-description' },
                        'Analise o seu desempenho comercial num mapa por estados e munic\xEDpios'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card' },
                    _react2.default.createElement(_Picture2.default, {
                        className: 'new-sales-features-img',
                        src: '/images/site/landing-pages/forca-vendas/curva.png',
                        alt: 'Recurso de curva ABC de clientes do for\xE7a de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                    }),
                    _react2.default.createElement(
                        'h4',
                        { className: 'card-title' },
                        'Curva ABC'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'card-description' },
                        'Saiba quem s\xE3o os clientes que trazem o maior retorno com a curva ABC'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card' },
                    _react2.default.createElement(_Picture2.default, {
                        className: 'new-sales-features-img',
                        src: '/images/site/landing-pages/forca-vendas/saude.png',
                        alt: 'Recurso de sa\xFAde da carteira de clientes do for\xE7a de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                    }),
                    _react2.default.createElement(
                        'h4',
                        { className: 'card-title' },
                        'Sa\xFAde da carteira'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'card-description' },
                        'Monitore a sa\xFAde da sua carteira de clientes'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card' },
                    _react2.default.createElement(_Picture2.default, {
                        className: 'new-sales-features-img',
                        src: '/images/site/landing-pages/forca-vendas/conversao.png',
                        alt: 'Relat\xF3rio de taxa de convers\xE3o do e-commerce do for\xE7a de vendas Mercos'
                        //mobileSrc={'/images/about/sobre-equipe-mobile.jpg'}
                    }),
                    _react2.default.createElement(
                        'h4',
                        { className: 'card-title' },
                        'Convers\xE3o do e-commerce'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'card-description' },
                        'Acompanhe as suas vendas e a intera\xE7\xE3o dos clientes com os produtos'
                    )
                )
            )
        )
    );
}

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/landing-pages/RepresentationSoftwarev2.jsx.f8b3be57.js